// extracted by mini-css-extract-plugin
module.exports = {"_newVvvoNummer":"VvvoNummerAuswahl__newVvvoNummer__2Ujfb"};